import React, { Component, PropTypes } from 'react';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import AcceptInvitation from './AcceptInvitation';
import { AuthStore, InvitationStore } from 'stores';
import { mixin, RefluxMixin } from 'Util';
import { InvitationActions } from 'actions';

export default class AcceptInvitationContainer extends mixin(
  RefluxMixin,
  Component
) {
  static displayName = 'AcceptInvitationContainer';

  static propTypes = {
    params: PropTypes.object
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  componentDidMount() {
    const { hash } = this.props.params;
    InvitationActions.check(hash);
  }

  listenToStores() {
    this.listenToStore(AuthStore, 'auth');
    this.listenToStore(InvitationStore, 'invitation');
  }

  render() {
    const { hash } = this.props.params;
    const { invitation } = this.state.invitation;
    const {
      usedByMe,
      loading,
      email,
      expired,
      accepted,
      accepting,
      used,
      limit,
      count,
      owner,
      course
    } = invitation;
    const { loggedIn, locale } = this.state.auth;
    return (
      <AcceptInvitation
        count={count}
        limit={limit}
        loading={loading}
        locale={locale}
        used={used}
        usedByMe={usedByMe}
        accepting={accepting}
        accepted={accepted || usedByMe}
        expired={expired}
        loggedIn={loggedIn}
        hash={hash}
        email={email}
        owner={owner}
        course={course}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Invitation/AcceptInvitationContainer.js